import { render, staticRenderFns } from "./PointTransactionList.vue?vue&type=template&id=280f6e35&scoped=true&"
import script from "./PointTransactionList.vue?vue&type=script&lang=js&"
export * from "./PointTransactionList.vue?vue&type=script&lang=js&"
import style0 from "./PointTransactionList.vue?vue&type=style&index=0&id=280f6e35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280f6e35",
  null
  
)

export default component.exports